import React from "react";
import Route from "react-router-dom/Route";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

/**
 * UserRoute: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Route, which only authenticated users can follow.
 * Otherwise redirects to /
 *
 * @param {*} props
 */
const UserRoute = ({ isAuthenticated, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

UserRoute.propTypes = {
  /**
   * component: function
   * React component which should be rendered if authenticated
   */
  component: PropTypes.func.isRequired,
  /**
   * isAuthenticated: Boolean
   * True, if the user is currently authenticated
   */
  isAuthenticated: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.user.uid
  };
}

export default connect(mapStateToProps)(UserRoute);



// WEBPACK FOOTER //
// ./src/routes/UserRoute.js